"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimordialSymbiosisAbilityHandler = exports.PrimordialSymbiosisActorAbilityFactory = exports.PrimordialSymbiosisAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class PrimordialSymbiosisAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.PrimordialSymbiosis;
        this.__typeName = "PrimordialSymbiosis";
    }
}
exports.PrimordialSymbiosisAbilityArgs = PrimordialSymbiosisAbilityArgs;
let PrimordialSymbiosisActorAbilityFactory = class PrimordialSymbiosisActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("PrimordialSymbiosis", "AllEnemies", 2);
    }
};
PrimordialSymbiosisActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("PrimordialSymbiosis")
], PrimordialSymbiosisActorAbilityFactory);
exports.PrimordialSymbiosisActorAbilityFactory = PrimordialSymbiosisActorAbilityFactory;
let PrimordialSymbiosisAbilityHandler = class PrimordialSymbiosisAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("parallel");
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(targetId => ({
                targetId,
                path: "line",
                end: "feet",
                type: "GroundedMultiElementComet",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Nature", 90)
                ]
            })),
            onHit: (sequence, _attack, _damages, { targetId }) => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Ticks(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.BurningEffectArgs("Focus", 10),
                        new core_1.PoisonedEffectArgs("Focus", 10),
                        new core_1.ChillEffectArgs("Focus", 10),
                        new core_1.SonicPulseEffectArgs("Focus", 10),
                    ].filter(() => (0, Random_1.randomPercent)() <= 50), true),
                });
            }
        });
    }
};
PrimordialSymbiosisAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.PrimordialSymbiosis)
], PrimordialSymbiosisAbilityHandler);
exports.PrimordialSymbiosisAbilityHandler = PrimordialSymbiosisAbilityHandler;
